import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 타입 정의
export interface Portfolio {
  id: string;
  title: string;
  description: string;
  type: string;
  icon: string;
  created_at: string;
}

export interface Review {
  id: string;
  author: string;
  rating: number;
  content: string;
  email?: string;
  created_at: string;
  approved: boolean;
}

export interface Consultation {
  id?: string;
  name: string;
  phone: string;
  email: string;
  service: string;
  budget: string;
  message: string;
  created_at?: string;
  status?: string;
}
